import { HStack } from "@chakra-ui/react";
import React from "react";
import { useTranslation } from "react-i18next";

import { Button } from "adminComponents/atoms/Button";
import { Card } from "adminComponents/atoms/Card";
import { Text } from "adminComponents/atoms/Text";
import { TemplateWithVerticalCenteredContent } from "adminComponents/templates/TemplateWithVerticalCenteredContent";
import { pxToRem } from "adminComponents/utils";
import { config } from "lib/constants";
import { useAuth } from "lib/features/auth";
import { useFetchCurrentUser } from "lib/features/users";
import { HeaderWithLanguagePicker } from "sharedComponents/atoms/HeaderWithLanguagePicker";

export const EmailVerification: React.FC = () => {
  const { authUser, pearToken } = useAuth();
  const { t } = useTranslation("admin", {
    keyPrefix: "emailVerification",
    useSuspense: false,
  });

  const { execute: fetchCurrentUser, isLoading: isFetchCurrentUserLoading } =
    useFetchCurrentUser();

  return (
    <TemplateWithVerticalCenteredContent
      headerContent={<HeaderWithLanguagePicker showSignOut />}
    >
      <HStack w="full" justifyContent="flex-end"></HStack>
      <Card
        marginTop={pxToRem(12)}
        borderColor="primary.tan"
        backgroundColor="primary.white"
        variant="adminCardMediumBorder"
      >
        <Text>{t("greeting", { givenName: authUser?.given_name })}</Text>
        <br></br>
        <Text>{t("cta", { email: authUser?.email })}</Text>
        <br></br>
        <HStack w="full" justifyContent="flex-end">
          <Button
            size="md"
            variant="adminButtonFilled"
            isLoading={isFetchCurrentUserLoading}
            onClick={() => {
              if (shouldGetNewPearToken(pearToken)) {
                fetchCurrentUser().then((userResp) => {
                  redirectToPDLEmailVerificationPage(userResp?.pear_token);
                });
              } else {
                redirectToPDLEmailVerificationPage(pearToken);
              }
            }}
          >
            {t("buttonLabel")}
          </Button>
        </HStack>
      </Card>
    </TemplateWithVerticalCenteredContent>
  );
};

const redirectToPDLEmailVerificationPage = (peartoken?: string) => {
  window.location.href = `${config.pearBaseUrl}/external-verify?pear_token=${peartoken}&target=GIANT_STEPS`;
};

// Checks for a valid non-expired pear token
const shouldGetNewPearToken = (pearToken?: string): boolean => {
  if (!pearToken) {
    return true;
  }

  let parsedJWT;
  try {
    parsedJWT = JSON.parse(atob(pearToken.split(".")[1]));
  } catch (e) {
    console.log("Error parsing token:", e);
    return true;
  }

  const currSec = Math.floor(new Date().valueOf() / 1000);
  if (parsedJWT.iat > currSec - 60 * 5) {
    return false;
  }

  return true;
};
